// packages block
import { Avatar, Box, IconButton, Menu, MenuItem } from '@mui/material';
import { FC, useContext, useRef, useState } from 'react';
// others block
import { PrimaryDots } from '../../assets/images';
import { AppContext, AuthContext } from '../../context';
import { ActionType } from '../../context/AppContextReducer';
import { CaseTypeMenuProps } from '../../interfaceTypes';
import { anchorOrigin, menuPaperStyles, transformOrigin } from '../../theme/styleConstants';
import { LawTypeActionType } from '../lawType/LawTypeReducer';

export const CaseTypeMenu: FC<CaseTypeMenuProps> = ({ caseType, dispatch }): JSX.Element => {
  const [open, setOpen] = useState<boolean>(false);
  const { isEdit, dispatch: appDispatch, isDeleteOpen } = useContext(AppContext)
  const { isAdmin } = useContext(AuthContext)
  const { id: caseTypeId } = caseType || {}

  const handleClick = () => setOpen(!open);
  const handleClose = () => setOpen(false);

  const anchorRef = {
    [caseTypeId!]: useRef<HTMLButtonElement>(null),
  };

  const handleViewModal = () => {
    handleClose();
    appDispatch({ type: ActionType.SET_IS_EDIT, isEdit: !isEdit })
    dispatch({ type: LawTypeActionType.SET_CURRENT_CASE_TYPE, currentCaseType: caseType })
  }

  const handleDeleteModal = () => {
    handleClose();
    appDispatch({ type: ActionType.SET_IS_DELETE_OPEN, isDeleteOpen: !isDeleteOpen })
    dispatch({ type: LawTypeActionType.SET_CURRENT_CASE_TYPE, currentCaseType: caseType })
  }

  return (
    <Box>
      <IconButton
        ref={anchorRef[caseTypeId!]}
        id={`long-button-${caseTypeId}`}
        aria-controls={`long-menu-${caseTypeId}`}
        aria-haspopup="true"
        onClick={handleClick}
      >
        <Avatar sx={{ bgcolor: 'transparent' }}>
          <PrimaryDots />
        </Avatar>
      </IconButton>

      <Menu
        id={`long-menu-${caseTypeId}`}
        anchorEl={anchorRef[caseTypeId!].current}
        open={open}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
        onClose={handleClose}
        PaperProps={menuPaperStyles}
      >
        <MenuItem onClick={handleViewModal}>View</MenuItem>

        {isAdmin && <MenuItem onClick={handleDeleteModal} color='primary.main'>Delete</MenuItem>}
      </Menu>
    </Box>
  );
};
